import Header from '../../components/Header'
import HeaderImage from '../../img/me1.jpg'
import {trainers} from '../../data'
import { FaFacebook, FaLinkedinIn } from "react-icons/fa"
import { FaWhatsapp } from "react-icons/fa"
import { FaYoutube } from "react-icons/fa"
import Trainer from '../../components/Trainer'
import './prof.css'
const Prof = () => {
    return (
       <>
            < Header title="Staff Technique" image={HeaderImage} >
                Découvrez notre équipe technique hautement qualifiée et passionnée. Nous avons rassemblé des experts chevronnés dans leur domaine, prêts à relever tous les défis techniques. Notre équipe est dévouée à offrir des solutions innovantes, à rester à la pointe de la technologie et à fournir un support technique exceptionnel à nos clients. Faites connaissance avec les visages qui rendent notre équipe technique exceptionnelle.
            </Header >
            <section className="trainers">
                <div className="container trainers__container">
                    {
                        trainers.map(({id,image,name,job,socials})=>{
                            return <Trainer key={id} image={image} job={job} name={name} socials={
                                [
                                    { icon: <FaWhatsapp/>, link: socials[0]},
                                    { icon: <FaFacebook/>, link: socials[1]},
                                    { icon: <FaLinkedinIn/>, link: socials[2]},
                                    { icon: <FaYoutube />, link: socials[3]}
                                ]
                            }/>
                            })
                    }
                </div>
            </section>
       </>
    )
}

export default Prof
